//#region Asset Imports

import { StateService } from "@uirouter/angularjs";

//#endregion

import { Api } from '../../api/api.module'
import { CorrelationType } from '../../../helpers/common-helper'

//#region Asset Imports

import './schema.scss'
import * as TEMPLATE from './schema.tpl.html'

//#endregion

export class SchemaDirective implements ng.IDirective {
    constructor() {

    }
    scope = {
        data: '=',
        itemTitle: '=',
        isEditMode: '=',
        disableRefresh: '='
    }

    controller = ['$scope', '$timeout', '$element', '$state', 'api', ($scope: ng.IScope, $timeout: ng.ITimeoutService, $element: JQuery, $state: StateService, api: Api) => {

        if ($scope['data']['correlationType'] == CorrelationType.Server) {
            $scope['data']['schemas'] = []
            $timeout(() => {
                $scope['data']['schemas'] = [{ schema: null }]
            })
        }

        $scope.$on('schemasLoaded', (event: ng.IAngularEvent, ...args: any[]) => {
            var schemas = args[0]
            $scope['data']['schemas'] = []
            $timeout(() => {
                $scope['data']['schemas'] = schemas
            })
        })

    }]
    restrict = 'E'
    template = TEMPLATE
    transclude = true
    replace = true
}